export const SESSION_KEY: string = 'MYP_CHECKOUT_FORM'
export const ENV: string = process.env.VITE_ENV || 'local'
export const DEFAULT_LOCALE: string = process.env.VITE_LOCALE || 'de'
export const SUPPORTED_LOCALE: string[] = ['de', 'en', 'fr']
export const ENTRYPOINT: string | undefined = process.env.VITE_API_ENTRYPOINT
export const CORE_API_ENTRYPOINT: string | undefined = process.env.VITE_CORE_API_ENTRYPOINT
export const COOKIE_POLIMAPS_BOX_KEYCY_KEY: string = 'COOKIE_POLICY'
export const CORONAVIRUS_TESTVERORDNUNG: string = 'https://www.bundesgesundheitsministerium.de/coronavirus/'
    + 'nationale-teststrategie/coronavirus-testverordnung.html'

// keep them for maps components
export const MAPS_BOX_KEY: string = process.env.VITE_MAPS_BOX_KEY || ''
export const MAPS_BOX_STYLE_URL: string = process.env.VITE_MAPS_BOX_STYLE_URL || ''

export const COOKIE_POLICY_KEY: string = 'COOKIE_POLICY'

export const GIT_VERSION: string = process.env.VITE_GIT_VERSION || 'v999.99-dev'

export const EXPIRY_OF_STORAGE_MINUTES: string = process.env.VITE_EXPIRY_OF_STORAGE_MINUTES || '5'
export const MY_PROBATIX_URL: string = process.env.VITE_MY_PROBATIX_URL || ''
export const SENTRY_DSN: string = process.env.VITE_SENTRY_DSN || ''

